import Button from '@/features/shared/Button';
import { MuiGrid, MuiTypography } from '@/features/shared/material-ui';
import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { memo, PropsWithChildren } from 'react';
import { CardResult } from '../Card';
import { CMSBlockProps } from './CMSBlock.interface';
import useStyles from './CMSBlock.styles';

const CMSBlock = ({
  listSuperheading,
  listTitle,
  contentList = [],
  labels,
  config,
  cta,
  theme = Theme.light,
  children,
}: PropsWithChildren<CMSBlockProps>) => {
  const classes = useStyles({});

  const rootClasses = clsx(classes.root, `${theme}-theme`);
  return (
    <div className={rootClasses}>
      {children}
      <div className={classes.heading}>
        <MuiTypography variant="h4">{listSuperheading}</MuiTypography>
        <MuiTypography variant="body1">{listTitle}</MuiTypography>
      </div>
      <div className={classes.content}>
        <MuiGrid container spacing={3}>
          {contentList.map((item: any, id: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <MuiGrid key={id} item xs={12} sm={6} md={6} lg={4} className="gtm-result">
              <CardResult {...item} labels={labels} config={config} />
            </MuiGrid>
          ))}
        </MuiGrid>
        {cta && (
          <div className={classes.cta}>
            <Button link={cta} />
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(CMSBlock);
